import { Switch } from "@mantine/core";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { useVariantDetailMutations } from "../../../../hooks/useVariantDetailMutations";
import { useToast } from "../../../../mantine/notifications/useToast";
export interface UsePaymentInformationToggleSwitchProps {
  variantId: number;
  usePaymentInformation: boolean;
}

function UsePaymentInformationToggleSwitch({
  variantId,
  usePaymentInformation
}: UsePaymentInformationToggleSwitchProps) {
  const { showToast, showErrorToast } = useToast();
  const queryClient = useQueryClient();

  const { editMutation } = useVariantDetailMutations(variantId);

  const navigate = useNavigate();

  async function handleChangeUsePaymentInformationToggleSwitch(
    isChecked: boolean
  ) {
    const result = await editMutation
      .mutateAsync({
        paragraph_6_payment_information_instead_of_credit: isChecked
      })
      .catch((error) => {
        showErrorToast(error);
      });

    queryClient.invalidateQueries({
      queryKey: ["paragraph6Credits", { variantId }]
    });

    if (
      result?.data?.paragraph_6_payment_information_instead_of_credit === true
    ) {
      showToast({
        type: "success",
        title: "Sie erstellen künftig Zahlungsinformationen!",
        message:
          "Mit dieser Einstellung werden Gutschriften durch Zahlungsinformationen ersetzt. Es werden keine Gutschriftennummernkreise eingebunden und es können keine Stornos zu Zahlungsinformationen angelegt werden."
      });
      navigate("../zahlungsinformationen");
    } else if (
      result?.data?.paragraph_6_payment_information_instead_of_credit === false
    ) {
      showToast({
        type: "success",
        title: "Sie erstellen künftig Gutschriften!",
        message:
          "Mit dieser Einstellung werden Zahlungsinformationen durch Gutschriften ersetzt. Es werden Gutschriftennummernkreise eingebunden und es können Stornos zu Gutschriften angelegt werden."
      });
      navigate("../gutschriften");
    }
  }

  return (
    <Switch
      checked={usePaymentInformation}
      disabled={editMutation.isPending}
      label="Die Gutschriftserstellung soll durch die Verwendung von Zahlungsinformation ersetzt werden."
      onChange={(e) =>
        handleChangeUsePaymentInformationToggleSwitch(e.target.checked)
      }
    />
  );
}

export { UsePaymentInformationToggleSwitch };
